export const detectTicketIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete ticket" || cleaned === "remove ticket") {
        return { intent: "delete_ticket" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) ticket/);
    if (deleteMatch) {
        return { intent: "delete_ticket", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create ticket") || cleaned.includes("add ticket")) {
        return { intent: "create_ticket" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create ticket named (.+)/);
    if (createMatch) {
        return { intent: "create_ticket", name: createMatch[1].trim() };
    }

    return null;
};
